import React from "react";
import { Menu } from "react-feather";
import { FaUserCircle } from "react-icons/fa";
import "./header.css";
import isGHMC from "../../Common/helper/helpar";

const Header = ({ onToggleSidebar }) => {
  const roleName = localStorage.getItem("userName");
  const isProd = isGHMC();

  return (
    <div className="header d-print-none">
      <div className="header-container">
        <div className="header-left" aria-hidden="true" />

        <div className="header-body">
          <div className="header-toolbar">
            <button
              type="button"
              className="sidebar-header-toggle"
              onClick={onToggleSidebar}
              aria-label="Toggle sidebar"
            >
              <Menu />
            </button>
            <h4 className={`${isProd ? "text-blue" : "text-red"}`}>
              Gurugram
            </h4>
          </div>

          <div className="header-body-right">
            <ul className="navbar-nav">
              <a href="#user-menu" className="m-0 header-user" title="User menu">
                <span className="header-user-avatar">
                  <FaUserCircle aria-hidden="true" />
                </span>
                <span className="header-user-text d-sm-flex d-none">
                  <span className="header-user-greeting">Signed in as</span>
                  <span className="header-user-name">{roleName}</span>
                </span>
              </a>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
